export default __webpack_public_path__ + "static/media/orphansDefaultDark.175e5146.png";